import React, { useEffect } from 'react';
import { advancedRoadmapsPlanReportSourcePlanResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanReportSourcePlanResource.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { useResource } from '@atlassian/react-resource-router';

const PLANS_DIRECTORY = '/jira/plans';

export const RedirectPlanReportToTimeline = (): React.JSX.Element | null => {
	const { data, loading } = useResource(advancedRoadmapsPlanReportSourcePlanResource);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sourceTimeline =
		data?.planId != null && data?.scenarioId != null
			? `/jira/plans/${data.planId}/scenarios/${data.scenarioId}/timeline`
			: null;

	useEffect(() => {
		if (loading) {
			return;
		}
		fireOperationalAnalytics(createAnalyticsEvent({}), 'planReportRedirect resolved', {
			destination: sourceTimeline === null ? 'plansDirectory' : 'planTimeline',
		});
	}, [createAnalyticsEvent, loading, sourceTimeline]);

	if (loading) {
		return null;
	}

	return <ScreenRedirect to={sourceTimeline ?? PLANS_DIRECTORY} persistSearchParams={false} />;
};
